<template>
  <div class="epicFury">

    <!-- Welcome Screen -->
    <div v-if="!started" class="welcome-screen">
      <div class="header-bar"></div>

      <div class="content">
        <div class="logo-wrapper">
          <img src="../../static/img/logoEDMv2.png" alt="Museum Ein Dor Logo" class="logo" />
        </div>

        <div class="divider"></div>

        <h1 class="activity-title"> בעקבות הקבר החיתי</h1>

        <p class="activity-description">
          במוזיאון נמצא קבר ייחודי בן 3000 שנה. זהותו עפופה במיסתורין, וחוקרים חושבים אולי הגיע ממלכת חת.
       <br>
              <br>

    <strong>התאימו בין הממצאים הארכיאולוגיים לתמונה.</strong>
        </p>

        <button class="start-button" @click="started = true">
          בואו נתחיל
        </button>
      </div>

      <div class="footer-bar"></div>
    </div>

    <!-- MultipleMatch Game -->
    <div v-else class="game-screen">
      <div class="game-header">
        <img src="../../static/img/logoEDMv2.png" alt="Museum Ein Dor Logo" class="game-logo" />
        <h2 class="game-title">פעילות בעקבות הקבר החיתי</h2>
      </div>

      <MultipleMatch
        :show-multiple-match="true"
        :points="$store.getters.points"
        :points-array-order="$store.getters.pointsArrayOrder"
        :point-num="0"
        @error-increment="errorNumber++"
        @error-decrement="errorNumber--"
        @quiz-completed="onQuizCompleted"
      />

      <div v-if="finished" class="finished-overlay">
        <div class="finished-card">
          <div class="finished-icon">✓</div>
          <h2>כל הכבוד!</h2>
          <p>סיימתם את הפעילות בהצלחה</p>
          <img src="../../static/img/burial.jpg" alt="burial" class="burial-img" />
          <p class="burial-text">בואו לראות אותי במוזיאון עין דור</p>
          <div class="social-row">
            <a href="https://www.facebook.com/eindormuseum" target="_blank" style="text-decoration: none; color: #1877F2;">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.532-4.697 1.313 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/eindormuseum/?hl=en" target="_blank" style="text-decoration: none; color: #E1306C;">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
              </svg>
            </a>
            <a href="https://eindormuseum.co.il/" target="_blank" style="text-decoration: none; color: #63C4C3;">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </a>
          </div>
          <button class="restart-button" @click="restart">
            נסו שוב
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MultipleMatch from './multipleMatch.vue';

export default {
  components: { MultipleMatch },
  data() {
    return {
      started: false,
      finished: false,
      errorNumber: 0,
    };
  },
  methods: {
    onQuizCompleted() {
      this.finished = true;
    },
    restart() {
      this.finished = false;
      this.started = false;
      this.errorNumber = 0;
    },
  },
};
</script>

<style scoped>
.epicFury {
  min-height: 100vh;
  background-color: #f5f0e8;
  direction: rtl;
}

/* ── Welcome Screen ── */
.welcome-screen {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(160deg, #e8f5e9 0%, #f5f0e8 50%, #e0f4f4 100%);
}

.header-bar {
  height: 8px;
  background: linear-gradient(90deg, #71A83F, #63C4C3);
}

.footer-bar {
  height: 8px;
  margin-top: auto;
  background: linear-gradient(90deg, #63C4C3, #71A83F);
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
}

.logo-wrapper {
  background: white;
  border-radius: 50%;
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(99, 196, 195, 0.3);
  margin-bottom: 28px;
}

.logo {
  width: 110px;
  object-fit: contain;
}

.divider {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #71A83F, #63C4C3);
  border-radius: 2px;
  margin-bottom: 28px;
}

.activity-title {
  font-size: 28px;
  font-weight: 800;
  color: #2d5a27;
  margin-bottom: 20px;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

.activity-description {
  font-size: 17px;
  color: #555;
  line-height: 1.8;
  max-width: 320px;
  margin-bottom: 40px;
  background: white;
  padding: 16px 20px;
  border-radius: 14px;
  border-right: 4px solid #71A83F;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06);
}

.start-button {
  background: linear-gradient(135deg, #71A83F, #5a8f32);
  color: white;
  font-size: 22px;
  font-weight: 700;
  border: none;
  border-radius: 50px;
  padding: 16px 60px;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(113, 168, 63, 0.4);
  transition: transform 0.15s, box-shadow 0.15s;
}

.start-button:active {
  transform: scale(0.97);
  box-shadow: 0 3px 10px rgba(113, 168, 63, 0.3);
}

/* ── Game Screen ── */
.game-screen {
  min-height: 100vh;
  background-color: #FFF1D9;
  position: relative;
}

.game-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(90deg, #71A83F, #63C4C3);
  color: white;
}

.game-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  background: white;
  border-radius: 50%;
  padding: 4px;
}

.game-title {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
}

/* ── Finished Overlay ── */
.finished-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.finished-card {
  background: white;
  border-radius: 24px;
  padding: 40px 32px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0,0,0,0.3);
}

.finished-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #71A83F, #63C4C3);
  color: white;
  font-size: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.finished-card h2 {
  font-size: 28px;
  font-weight: 800;
  color: #2d5a27;
  margin-bottom: 10px;
}

.finished-card p {
  font-size: 17px;
  color: #555;
  margin-bottom: 16px;
}

.burial-img {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 14px;
  object-fit: cover;
}

.burial-text {
  font-size: 18px;
  font-weight: 700;
  color: #2d5a27;
  margin-bottom: 16px !important;
}

.social-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}


.restart-button {
  background: linear-gradient(135deg, #63C4C3, #4aa8a7);
  color: white;
  font-size: 18px;
  font-weight: 700;
  border: none;
  border-radius: 50px;
  padding: 12px 40px;
  cursor: pointer;
}
</style>
